import {getUserIdForGoogleAnalytics} from "cloud-central-utils/encryption";
import {aggregatePath, trackPageView, trackEvent} from "../mrTracker";
import {history} from "../../store";
import querystring from "query-string";
import { get } from "lodash";
import { isVirtualTourEnabled } from "offline/utils";
import { isNcl } from "utils/app/utils";
import { getNetAppInternalString, NETAPP_INTERNAL_STRINGS } from "./utils";

//Internal accounts taken from auth0
const NETAPP_INTERNAL_ACCOUNTS = [NETAPP_INTERNAL_STRINGS.NetAppTest, NETAPP_INTERNAL_STRINGS.NetAppCourse, NETAPP_INTERNAL_STRINGS.NetAppDemo];

const getInternalAccount = authResult => get(authResult, 'idTokenPayload["http://cloud.netapp.com/internal"]');

const getUserEmail = authResult => get(authResult, 'idTokenPayload.email') ||
    get(authResult, 'idTokenPayload["http://cloud.netapp.com/user_metadata"].email') || '';

const isNetappUser = authResult => {
    const internalAccount = getInternalAccount(authResult);
    return internalAccount === NETAPP_INTERNAL_STRINGS.NetApp || NETAPP_INTERNAL_ACCOUNTS.includes(internalAccount) ||
        getUserEmail(authResult).toLowerCase().endsWith('netapp.com');
};

export const trackGaBeforeLogin = () => {
    if(process.env.REACT_APP_IS_SAAS !== "true") {
        return;
    }

    const search = querystring.parse(window.location.search);
    const tagId = process.env.REACT_APP_GOOGLE_ANALYTICS_TAG;

    if(search?.redirectFrom && search.redirectFrom === "spot" && search.spotOrgId) {
        window.gtag('config', tagId, {
            'page_location': window.origin + aggregatePath({location: window.location}),
            'send_page_view': false,
            'transport_type': 'beacon'
        });

        const label = search.spotOrgId;

        trackEvent({category: "Anon", action: `RedirectFrom:${search.redirectFrom}`, label})
    }
}

export const setFullStory = authResult => {
    if (process.env.REACT_APP_IS_SAAS !== "true") {
        return;
    }
    if (isFullStoryEnabled() && authResult?.idTokenPayload) {
        getUserIdForGoogleAnalytics(authResult.idTokenPayload.sub)
            .then(userId => {
                window.FS('setIdentity', {
                    uid: userId,
                    properties: {
                        "internal": authResult.idTokenPayload['http://cloud.netapp.com/internal'],
                        "isNetappDomain": isNetappUser(authResult)
                    }
                });
            });
    }
};

export const setGoogleAnalytics = authResult => {
    if(process.env.REACT_APP_IS_SAAS !== "true") {
        return;
    }

    const tagId = process.env.REACT_APP_GOOGLE_ANALYTICS_TAG;
    const idTokenPayload = authResult.idTokenPayload;

    if (idTokenPayload) {
        getUserIdForGoogleAnalytics(idTokenPayload.sub)
            .then(userId => {
                window.gtag('set', { 'user_id': userId });
                if (isVirtualTourEnabled()) {
                    trackEvent({
                        event_category: 'user_login',
                        action: "Console_Simulator_Login",
                        label: 'UserId',
                        value: userId
                    });
                }
            });

        const idTokenPayloadInternal = getInternalAccount(authResult);
        if (NETAPP_INTERNAL_ACCOUNTS.includes(idTokenPayloadInternal)) {
            console.log(`Analytics Disabled for ${idTokenPayloadInternal} Account`);
            window[`ga-disable-${tagId}`] = true;
        } else {
            window.gtag('config', tagId, {
                'page_location': window.origin + aggregatePath({location: window.location}),
                'send_page_view': false
            });
            if (idTokenPayloadInternal === 'NetApp') {
                //verified netapp email or netapp federation
                //federations: NetAppSAML || TestSamlConn || netapp-waad || azuread || BlueXP-Federation;
                window.gtag('set', 'user_properties', {internalUser: 'YES'});
            } else {
                if (isNetappUser(authResult)) {
                    //unverified netapp email
                    window.gtag('set', 'user_properties', {internalUser: 'UNKNOWN'});
                }
                else {
                    window.gtag('set', 'user_properties', {internalUser: 'NO'});
                }
            }
        }
    }
};

export const setFullStoryUserValues = (userProperties) => {
    if (isFullStoryEnabled()) {
        window.FS('setProperties', {
            type: 'user',
            properties: userProperties
        });
    }
};

export const setGAUserProperties = (userProperties) => {
    if (process.env.REACT_APP_IS_SAAS === "true" && window.gtag) {
        window.gtag('set', 'user_properties', userProperties);
    }
};

export const enableGAPageViewTracking = () => {
    if (process.env.REACT_APP_IS_SAAS === "true" && window.gtag) {
        history.listen((location) => {
            trackPageView({ location });
        });
    }
};

export const setFullStoryForNcl = (authResult) => {
    if (!isFullStoryEnabled()) {
        return;
    }

    getUserIdForGoogleAnalytics(authResult?.idTokenPayload?.sub || '')
        .then(userId => {
            const internal = getNetAppInternalString(authResult?.idTokenPayload?.email);
            window.FS('setIdentity', {
                uid: userId,
                properties: {
                    "internal": internal,
                    "isNetappDomain": !!internal
                }
            });
        });
};

export const isFullStoryEnabled = () => {
    return (process.env.REACT_APP_USE_FULLSTORY === "true" || isNcl()) && window.FS;
};
